module.exports = "/_next/static/images/Belanja_di_Toko_Mini_Web-Banner-8f5066db89519325a9d8c2bdbf1a4e08.jpg";